// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"style_NotFoundPage__RemXF","container":"style_container__ISJtc"};